import React from 'react';
import Modal, { usePreventDismissing } from '../Modal';
import { useMessageLibrary } from '../../Data/Thread';
import nl2br from 'react-nl2br';
import Loading from '../Loading';
import Button from '../Button/Button';
import { useDialogues } from '../Dialogues';

const SavedReplies = ({isOpen, setIsOpen, entityModel, onChanged}) => {
    return <Modal title="Saved replies" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{entityModel, onChanged}} />}
    </Modal>
}

const Inner = ({entityModel, onChanged}) => {
    const {messages, deleteMessage} = useMessageLibrary(entityModel);
    const {confirm, isDialogueOpen} = useDialogues();

    usePreventDismissing(isDialogueOpen);

    if (!messages) {
        return <Loading />;
    };

    return <div className="flex flex-col divide-y">
        {messages.map(reply => <div key={reply.id} className="flex flex-row py-2">
            <div className="grow prose prose-sm">
                <strong>{reply.title}</strong><br />
                <span className="tet-muted text-xs">
                    {nl2br(reply.content)}
                </span>
            </div>
            <div className="grow-0 shrink-0">
                <Button icon="Trash"
                    theme="lightDanger"
                    onClick={() => confirm(
                        {
                            theme: 'danger',
                            title: 'Delete saved reply',
                            message: `Are you sure you want to delete the "${reply.title} reply?`,
                        },
                        () => deleteMessage(reply.id).then(() => onChanged && onChanged())
                    )}
                />
            </div>
        </div>)}
    </div>
}

export default SavedReplies;
